import cn from 'classnames'
import { ReactNode, useContext } from 'react'

import { ROUND_TABLE_TRANSLATION_KEYS } from '../../configs/translations'
import { RoundTableContext } from '../../context/RoundTableContext'
import { RoundTableSectionMark } from '../roundTableSectionMark/RoundTableSectionMark'

import styles from './RoundTableSection.module.scss'

interface IProps {
  children: ReactNode
  floatingLabel?: boolean
  showLabel?: boolean
  enabled?: boolean
  exportDescription?: keyof typeof ROUND_TABLE_TRANSLATION_KEYS
}

export const RoundTableSection = ({
  children,
  enabled = true,
  showLabel = false,
  floatingLabel = false,
  exportDescription,
}: IProps) => {
  const { ready } = useContext(RoundTableContext)
  const highlighted = ready && enabled
  return (
    <div
      className={cn({
        [styles.section]: highlighted,
        [styles.floatingLabel]: highlighted && floatingLabel,
      })}
    >
      {highlighted && (exportDescription || showLabel) && (
        <div className={styles.scope}>
          <RoundTableSectionMark exportDescription={exportDescription} />
        </div>
      )}
      <div key="content" className={highlighted ? styles.sectionContent : undefined}>
        {children}
      </div>
    </div>
  )
}
